var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-card",
        { staticClass: "d-flex flex-row justify-start", attrs: { flat: "" } },
        [
          _c(
            "v-col",
            { staticClass: "px-0", attrs: { sm: "5" } },
            [
              _c("v-card", { attrs: { flat: "" } }, [
                _c("h3", { staticClass: "text-subtitle-1" }, [
                  _vm._v(_vm._s(_vm.label)),
                ]),
              ]),
              _c(
                "v-card",
                {
                  staticClass: "d-flex flex-row text-caption",
                  attrs: { flat: "" },
                },
                [
                  _c("p", { staticClass: "text-caption" }, [
                    _vm._v(_vm._s(_vm.tooltip)),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "v-card",
            { staticClass: "grow d-flex", attrs: { flat: "" } },
            [
              _c("v-text-field", {
                staticClass: "mx-2",
                attrs: {
                  label: "Initial Hour",
                  hint: "24-hour format",
                  suffix: "hours",
                  min: 0,
                  max: 23,
                  type: "number",
                },
                model: {
                  value: _vm.peakHours[0],
                  callback: function ($$v) {
                    _vm.$set(_vm.peakHours, 0, $$v)
                  },
                  expression: "peakHours[0]",
                },
              }),
              _c("v-text-field", {
                staticClass: "mx-2",
                attrs: {
                  label: "End Hour",
                  hint: "24-hour format",
                  suffix: "hours",
                  min: 0,
                  max: 23,
                  type: "number",
                },
                model: {
                  value: _vm.peakHours[1],
                  callback: function ($$v) {
                    _vm.$set(_vm.peakHours, 1, $$v)
                  },
                  expression: "peakHours[1]",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }